const INVITE_STEP_KEY = (userId) => `xph_invite_step_done_${userId}`;

export function planAllowsTeamInvites(planId) {
  const normalized = String(planId || '').toLowerCase();
  return normalized === 'professional' || normalized === 'promax' || normalized === 'enterprise';
}

export function hasCompletedInviteStep(userId) {
  if (!userId) return true;
  try {
    return Boolean(localStorage.getItem(INVITE_STEP_KEY(userId)));
  } catch {
    return false;
  }
}

export function markInviteStepComplete(userId) {
  if (!userId) return;
  try {
    localStorage.setItem(INVITE_STEP_KEY(userId), 'true');
  } catch {
    // ignore
  }
}

export function isPaidSubscriptionPlan(planId) {
  const normalized = String(planId || '').toLowerCase();
  return Boolean(normalized && normalized !== 'free');
}
